import styles from "../../../LoanRequestPage.module.scss";
import { AttachmentIcon } from "../../../../../../assets/icons";
import { OrderType } from "../../../../../../model/orders/orders";
import moment from "moment";

type Props = {
	orderDetails: OrderType;
};

const EmploymentDetailsTab = ({ orderDetails }: Props) => {
	const { customer } = orderDetails;
	return (
		<section className={styles.detailsTabWrapper}>
			<div className={styles.detailsContent}>
				<div className={styles.item}>
					<div className={styles.label}>Company Name</div>
					<div className={styles.value}>{customer.companyName}</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Date Joined</div>
					<div className={styles.value}>{customer.joinedAt ? moment(customer.joinedAt).format("MMM DD, YYYY") : "/"}</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Employment Type</div>
					<div className={styles.value}>{customer.employmentType}</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Employment Contract</div>
					<div className={styles.value}>
						<div className={styles.attachment}>
							{customer.employmentContractUrl ? (
								<>
									<AttachmentIcon />
									<a href={customer.employmentContractUrl} target="_blank" rel="noreferrer">
										View attachment
									</a>
								</>
							) : (
								"/"
							)}
						</div>
					</div>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Linkedin Profile</div>
					<div className={styles.value}>
						{customer.linkedInUrl ? (
							<a href={customer.linkedInUrl} target="_blank" rel="noreferrer">
								{customer.linkedInUrl}
							</a>
						) : (
							"/"
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

export default EmploymentDetailsTab;
